// src/hooks/filter/useFilterOptions.js
import { useMemo } from 'react';
import { processCategoriesToShow } from '../../utils/filter/filterProcessors';

export const useFilterOptions = (
    filterTerms,
    selectedFilters,
    categoriesToShow = [],
    availableSubcategories,
    hasCategory
) => {
    // Process categories from WordPress configuration
    const processedCategories = useMemo(() => {
        return processCategoriesToShow(categoriesToShow, filterTerms?.categories);
    }, [categoriesToShow, filterTerms?.categories]);
    
    // Process filter terms directly without needing products
    const processedFilterTerms = useMemo(() => {
        if (!filterTerms) return {};
        
        const processed = { ...filterTerms };
        
        // Override categories with processed categories from WordPress
        if (processedCategories.length > 0) {
            processed.categories = processedCategories;
        }
        
        // Handle subcategories based on selected category
        if (hasCategory && availableSubcategories && availableSubcategories.size > 0 && selectedFilters?.category) {
            // Filter subcategories to only show ones available for the selected category
            let filteredSubcategories = [];
            
            if (filterTerms.subcategories && Array.isArray(filterTerms.subcategories)) {
                filteredSubcategories = filterTerms.subcategories.filter(subcat => {
                    return availableSubcategories.has(subcat);
                });
            }
            
            // Make sure to include any currently selected subcategory
            if (selectedFilters.subcategory && !filteredSubcategories.includes(selectedFilters.subcategory)) {
                filteredSubcategories.push(selectedFilters.subcategory);
            }
            
            processed.subcategories = filteredSubcategories;
        } else if (!selectedFilters?.category) {
            // No category selected, show all subcategories
            processed.subcategories = filterTerms.subcategories || [];
        }
        
        return processed;
    }, [
        filterTerms, 
        selectedFilters, 
        processedCategories, 
        hasCategory, 
        availableSubcategories
    ]);
    
    return {
        processedFilterTerms,
        processedCategories
    };
};
